<ng-container *ngIf="hasData; else noData">
  <div class="header">
    <app-show-header-data
      [id]="entityId"
      [state]="state"
      [title]="title"
      [statusModule]="statusModule"></app-show-header-data>

    <app-show-create-update-data
      *ngIf="metaEntity"
      [createUpdateEntity]="metaEntity"></app-show-create-update-data>

    <ng-content select="[detail-header-extra]"></ng-content>

    <ng-container *ngIf="showActionsAt('top')">
      <app-dynamic-action-button-row
        [actions]="actions"
        [requestEntity]="metaEntity"
        [currentUser]="currentUser"
        (onActionClickedEvent)="onActionClicked($event)"></app-dynamic-action-button-row>
    </ng-container>

    <app-hint-card
      *ngIf="hint && (hint.text || hint.html)"
      [type]="hint.type"
      [outlined]="true"
      class="hint-card"
      [cardStyle]="{
        backgroundColor: 'white'
      }">
      <ng-container *ngIf="hint.html; else plainHint">
        <div [innerHTML]="hint.html | safeHtmlPipe"></div>
      </ng-container>
      <ng-template #plainHint>
        {{ hint.text }}
      </ng-template>
    </app-hint-card>

    <app-show-errors [errorFormList]="errors"></app-show-errors>
  </div>

  <div class="content">
    <ng-content select="[detail-body]"></ng-content>
  </div>

  <ng-container *ngIf="showActionsAt('bottom')">
    <div class="footer">
      <app-dynamic-action-button-row
        [actions]="actions"
        [requestEntity]="metaEntity"
        [currentUser]="currentUser"
        (onActionClickedEvent)="onActionClicked($event)"></app-dynamic-action-button-row>
    </div>
  </ng-container>
</ng-container>

<ng-template #noData>
  <ng-container *ngIf="!errorMessage && loading">
    <app-loading-overlay />
  </ng-container>
  <ng-container *ngIf="errorMessage">
    <app-error [errorMessage]="errorMessage" />
  </ng-container>
</ng-template>
